export class addedFeatureFlag {
    constructor(flagDescription, enabledForAll, userName, flagName, serviceName) {
        this.flagDescription = flagDescription;
        this.enabledForAll = enabledForAll;
        this.userName = userName;
        this.flagName = flagName;
        this.serviceName = serviceName;
    }
}